import Services from "../../services";

class InputPenerimaanBarangApi {
  // API SERVER
  get(params) {
    return Services.get("hrdu/approval_input_penerimaan_barang/list", {
      params,
    });
  }

  getHistory(params) {
    return Services.get("hrdu/approval_input_penerimaan_barang/history/list", {
      params,
    });
  }

  getSingle(params) {
    return Services.get("hrdu/approval_input_penerimaan_barang/detail", {
      params,
    });
  }

  approve(data) {
    return Services.post("hrdu/approval_input_penerimaan_barang/approve", data);
  }
}

export default new InputPenerimaanBarangApi();
